import { useCallback, useEffect, useState, type KeyboardEvent } from 'react'

function isMacPlatform(): boolean {
	return (
		typeof navigator !== 'undefined' &&
		/Mac|iPhone|iPad|iPod/.test(navigator.platform)
	)
}

export function getModEnterShortcutLabel(): string {
	return isMacPlatform() ? '⌘↵' : 'Ctrl+↵'
}

interface UseSendReplyShortcutOptions {
	canSend: boolean
	isSending?: boolean
}

export function useSendReplyShortcut(
	onSend: () => void,
	options: UseSendReplyShortcutOptions
) {
	const { canSend, isSending = false } = options
	const [shortcutLabel, setShortcutLabel] = useState('⌘↵')

	useEffect(() => {
		setShortcutLabel(getModEnterShortcutLabel())
	}, [])

	const onKeyDown = useCallback(
		(e: KeyboardEvent<HTMLTextAreaElement>) => {
			if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
				e.preventDefault()
				if (canSend && !isSending) {
					onSend()
				}
			}
		},
		[canSend, isSending, onSend]
	)

	return { onKeyDown, shortcutLabel }
}
